import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import * as ConstantsStore from '../../../store/constants';
import * as AdminStore from '../../../store/admin';

import { RequirementTypeValidationHolders } from '../../../components/admin/requirementTypes/RequirementTypeValidationHolders';

export default connect(
    (state: ApplicationState) => ({
        ...AdminStore.plainActions,
    }),
    {},
)(RequirementTypeValidationHolders as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
